module.exports = __webpack_public_path__ + "assets/img/stoopzz.209684f7.png";